<template>
  <div :class="`locale-changer flex py-3 ${!landingPage && 'border-b-[1px]'}`">
    <input
      type="radio"
      id="en"
      value="en"
      name="radio"
      v-model="$i18n.locale"
    />
    <label for="en">EN</label>
    |
    <input
      type="radio"
      id="de"
      value="de"
      name="radio"
      v-model="$i18n.locale"
    />
    <label for="de">DE</label>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LoginView",
  props: {
    landingPage: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    return {};
  },
  watch: {
    "$i18n.locale": function (newVal) {
      localStorage.setItem("last-locale", newVal);
    },
  },
});
</script>
<style scoped lang="scss">
.locale-changer input[type="radio"] {
  opacity: 0;
  position: fixed;
  width: 0;
}

.locale-changer label {
  display: inline-block;
  padding: 0 20px;
  font-family: sans-serif, Arial;
  font-size: 16px;
  color: lightgray;
}

.locale-changer input[type="radio"]:checked + label {
  color: black;
}

.locale-changer label {
  cursor: pointer;
}
</style>
